<mat-card appearance="outlined" color="primary" data-tfa="mat-card-accueil">
  <mat-card-header>
    <mat-card-title data-tfa="mat-card-accueil-title">
      <h1 i18n="Title|Titre message de bienvenue de l'application@@PIECES-WELCOME-MESSAGE">
        PIECES-WELCOME-MESSAGE
      </h1>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content data-tfa="mat-card-accueil-content">
    <p></p>
  </mat-card-content>
</mat-card>
